/** Intervalo <= 0 é tratado como "identidade sonora desligada". */
export function deveDispararLocucao(contador: number, intervaloFaixas: number): boolean {
  if (intervaloFaixas <= 0) return false;
  if (contador <= 0) return false;
  return contador % intervaloFaixas === 0;
}
